import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from '#views/App.jsx';

import { $app } from './boot.js';
import { StateProvider } from './state.jsx';

// disableDebugLog();

const app = $app.use;
const stopApp = app.startApp();

console.debug('[AppContent] Root AppContent component mounted', {
  timestamp: new Date().toISOString(),
  location: globalThis.location.href,
});

// Log unhandled errors
function handleError(event: ErrorEvent) {
  // Handle ResizeObserver loop errors gracefully
  if (event.message?.includes('ResizeObserver loop completed with undelivered notifications')) {
    console.debug('ResizeObserver loop error (handled):', event.message);
    return; // Don't log as error or throw
  }
  
  console.error(
    `[AppError] Unhandled error: ${event.message} at ${event.filename}:${event.lineno}:${event.colno}`,
    event.error,
  );
  throw event.error;
}

// Log unhandled promise rejections
function handleUnhandledRejection(event: PromiseRejectionEvent) {
  console.error('Unhandled promise rejection', event);
}

globalThis.addEventListener('error', handleError);
globalThis.addEventListener('unhandledrejection', handleUnhandledRejection);

const rootElement = document.querySelector('#root');
if (!rootElement) {
  throw new Error('Failed to find root element');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <StateProvider app={$app}>
      <App />
    </StateProvider>
  </React.StrictMode>,
);
